import React from "react";

export const Image = ({ title, image }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={image} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={image}  alt={title} />
        </a>{" "}
      </div>
    </div>
  );
};
